const theme = {
    color: "#16A34A",
    textColor: "#fff",
    backgroundColor: "#EEF0F2",
    grayColor: "#000000",
    themeColor: "#199948",
    breakPoint :{
        'tablet' : "768px",
        
    }
}


export default theme;